<template>
  <modalGeneric
    :title="modalConfig.title"
    @closeModal="close"
    :theme="`peopleList ${listType}`"
    :icon="modalConfig.icon">
    <section class="containerPeopleListModal" ref="containerPeopleListModalScrollListener">
      <section class="containerPeopleListModal__itemContainer" v-for="(user, index) in usersList" :key="index">
        <a class="containerPeopleListModal__itemContainer--item" :class="{'inactiveUser': !user.displayUserInfo}" target="_self" :href="profileUrl(user)" @click.stop="close">
          <div class="imgContainer">
            <img class="imgContainer__image" :src="thumbnail(user.thumbnail)" :alt="user.name+'\'s profile photo'" />
          </div>
          <span class="userName" style="-webkit-box-orient: vertical;" :title="user.name">{{user.name}}</span>
        </a>
      </section>
      <div class="containerPeopleListModal__spinnerContainer" v-if="!isCompleteLoading">
        <spinnerGeneric class="containerPeopleListModal__spinnerContainer--spinner"></spinnerGeneric>
      </div>
    </section>
  </modalGeneric>
</template>

<script>
import { onMounted, onUnmounted, computed, ref, reactive } from 'vue'
import modalGeneric from '../modalGeneric/modalGeneric'
import spinnerGeneric from '../spinnerGeneric/spinnerGeneric'
import { getCollectionCoOwners, getItemLikes, cancelLikesRequest } from '../../../services'
import configEndPoints from '../../../config.json'
import { config } from './peopleListModal.json'

export default {
  name: 'peopleListModalGeneric',
  emits: ['close'],
  components: {
    spinnerGeneric,
    modalGeneric
  },
  props: {
    listType: {
      type: String,
      default: 'likes'
    },
    itemId: {
      type: String,
      required: false
    },
    participantsProp: {
      type: Array,
      required: false
    }
  },
  setup (props, { emit }) {
    const appConfig = reactive(configEndPoints)
    const modalConfig = reactive(config[props.listType])
    const isCompleteLoading = ref(false)
    const containerPeopleListModalScrollListener = ref(null)
    const loadingUsers = ref(false)
    const usersList = ref([])
    const page = ref(1)

    /**
     * @description Get profile picture
     * @param thumbnailUrl url of the thumbnail
     */
    const thumbnail = computed(() => {
      return thumbnailUrl => thumbnailUrl || require('../../../assets/avatar.jpg')
    })

    /**
     * @description Retrieves the url of user profile.
     * @param user info of the user.
     */
    const profileUrl = computed(() => (user) => {
      if (user && user.displayUserInfo) {
        return `${appConfig.apps_url.people}/profile/${user.id}?pageToken=${localStorage.getItem('sessionToken')}`
      } else {
        return null
      }
    })

    onMounted(() => {
      getMoreUsers(true)
      if (containerPeopleListModalScrollListener.value) {
        containerPeopleListModalScrollListener.value.addEventListener('scroll', handleScroll)
      }
    })

    onUnmounted(() => {
      if (props.listType === 'likes') cancelLikesRequest()
    })

    /**
     * @description Send event to close the modal
     */
    function close () {
      emit('close')
    }

    /**
      * @description Call server to get collections items
      */
    function handleScroll (e) {
      if ((e.target.scrollHeight - containerPeopleListModalScrollListener.value.scrollTop - 45) <= containerPeopleListModalScrollListener.value.clientHeight && !isCompleteLoading.value) {
        if (!loadingUsers.value) getMoreUsers()
      }
    }

    /**
     * @description Request next set of users to service
     * @param isFirstTime flag to know if is the first time to call service
     */
    function getMoreUsers (isFirstTime = false) {
      loadingUsers.value = true
      if (props.listType === 'likes') {
        getItemLikes(props.itemId, page.value).then((response) => loadUsers(response, isFirstTime))
      } else if (props.listType === 'coOwners') {
        getCollectionCoOwners(props.itemId, 12, page.value).then((response) => loadUsers(response, isFirstTime))
      } else {
        const pageParticipants = []
        const initialIndex = (page.value - 1) * 12
        const finalIndex = initialIndex + 12
        for (let index = initialIndex; index < finalIndex; index++) {
          if (index === props.participantsProp.length) {
            isCompleteLoading.value = true
            break
          } else {
            pageParticipants.push({
              displayUserInfo: true,
              email: props.participantsProp[index].email,
              name: props.participantsProp[index].name,
              thumbnail: props.participantsProp[index].thumbnail,
              id: props.participantsProp[index].ecCode
            })
          }
        }
        loadUsers(pageParticipants, isFirstTime)
      }
    }

    /**
     * @description Add new users to users list
     * @param usersToAdd the new users to add
     */
    function addUsersToList (usersToAdd) {
      usersToAdd.forEach((value) => {
        usersList.value.push(value)
      })
      page.value += 1
    }

    /**
     * @description Actions to execute to load the users in the modal
     * @param users the users to load
     * @param isFirstTime flag to know if is the first time to call service
     */
    function loadUsers (users, isFirstTime = false) {
      addUsersToList(users)
      if (isFirstTime && window.innerWidth <= 575 && containerPeopleListModalScrollListener.value.offsetHeight > 620 && users.length >= 12) {
        getMoreUsers()
      }
      if (users.length < 12) {
        isCompleteLoading.value = true
      }
      loadingUsers.value = false
    }

    return {
      close,
      thumbnail,
      isCompleteLoading,
      loadingUsers,
      containerPeopleListModalScrollListener,
      usersList,
      modalConfig,
      profileUrl
    }
  }
}
</script>
